import React from "react";
import NumberFormat from 'react-number-format';


export function EnergiaHtml({
    ...props
}) {

    return (
        <>
            <NumberFormat thousandSeparator={true} suffix={' kWh'}
                displayType={'text'}
                decimalSeparator=","
                          decimalScale={2}
                thousandSeparator="."
                value={props.value}
            />
        </>
    );
}
